// 営業時間帯（16:00〜翌05:55）の時刻選択肢。既定は5分刻み
// （ドラムピッカー標準化。cast_app側の buildStartTimeOptions と同じ規約）
export const buildTimeOptions = (stepMinutes = 5) => {
  const options = []
  for (let h = 16; h <= 29; h += 1) {
    for (let m = 0; m < 60; m += stepMinutes) {
      const displayH = h >= 24 ? h - 24 : h
      options.push(`${String(displayH).padStart(2, '0')}:${String(m).padStart(2, '0')}`)
    }
  }

  return options
}

// 現在時刻を5分に丸めてHH:mmで返す（選択肢の初期値用）
export const currentTimeRounded = (stepMinutes = 5) => {
  const now = new Date()
  const minutes = Math.round((now.getHours() * 60 + now.getMinutes()) / stepMinutes) * stepMinutes
  const wrapped = ((minutes % 1440) + 1440) % 1440

  return `${String(Math.floor(wrapped / 60)).padStart(2, '0')}:${String(wrapped % 60).padStart(2, '0')}`
}
